// Patch fetch to intercept requests to the story-theme API
const originalFetch = window.fetch;
window.fetch = async function(resource, options) {
  // Check if the request URL matches the API endpoint used by the scripts
  if (
    typeof resource === 'string' &&
    resource.includes('story-theme.com/api/v1/shops/check/')
  ) {
    // Return a fake "success" response
    return Promise.resolve(new Response(JSON.stringify({
      status: "success",
      data: {
        shop: [
          {
            _id: "fakeid",
            user: [
              {
                _id: "fakeuserid",
                state: "active",
                maxShops: null,
                rank: 0,
                id: "fakeuserid"
              }
            ],
            url: "yourshop.myshopify.com",
            id: "fakeid"
          }
        ]
      }
    }), {
      status: 200,
      headers: { 'Content-Type': 'application/json' }
    }));
  }
  // For all other requests, use the original fetch
  return originalFetch.apply(this, arguments);
};
